// extracted by mini-css-extract-plugin
module.exports = {"menuList":"_28XAEY"};